import React, { useState, useContext, useEffect } from 'react';
import Panel from '../../../../components/Panel';
import useAPI from '../../../../hooks/useAPI';
import useFlash from '../../../../hooks/useFlash';
import FlashMessage from '../../../../components/FlashMessage';
import AuthContext from '../../../../contexts/AuthContext';
import ComponentBusy from '../../../../components/ComponentBusy';
import ValueDisplay from '../../../../components/ValueDisplay';

export default function SystemInformation ({ onLoad, onLoadEnd }) {
    const { system } = useContext(AuthContext);

    const [loading, setLoading] = useState(true);
    const [systemOwner, setSystemOwner] = useState({});
    const [paymentData, setPaymentData] = useState({});
    const [systemData, setSystemData] = useState({});

    const api = useAPI();
    const { messages, flash, remove } = useFlash();

    const load = ()=>{
        onLoad();
        setLoading(true);
        
        api.json('GET',  '/systems/' + system.id + '/owner-summary')
           .then(r=>r.json())
           .then((r)=>{
              if(r.errors){
                flash(Array.isArray(r.errors) ? r.errors[0] : Object.values(r.errors)[0]);
                return;
              }

              const {
                owner, payment, system
              } = r.data;

              setSystemOwner(owner);
              setPaymentData(payment)
              setSystemData(system)
           })
           .catch(e=>alert(e))
           .then(()=>{
                onLoadEnd();
                setLoading(false);
            })
    }

    useEffect(()=>{
        load();
        // eslint-disable-next-line
    }, []);

    if (loading) {
        return <ComponentBusy />;
    }

    return (
        <div className='account-settings'>
            <FlashMessage messages={messages} onRemove={remove} />
            <Panel
                title="System Information"
                contentStyle={{ padding: 20 }}
                headerStyle={{
                    borderBottomWidth: 1,
                    borderStyle: 'solid',
                    borderColor: '#E2E3E8',
                    padding: 20
                }}
            >
                <div className='row'>
                    <div className='col-12 col-xl-6'>
                        <ValueDisplay
                            label="System Owner"
                            value={systemOwner.person_name || '--'}
                        />
                    </div>
                    <div className='col-12 col-xl-6'>
                        <ValueDisplay
                            label="System Address"
                        >
                            {
                                systemData.address ? (
                                    <>
                                        {systemData.address.street && <>
                                            {systemData.address.street}<br />
                                        </>}
                                        {systemData.address.street_2 && <>
                                            {systemData.address.street_2}<br />
                                        </>}
                                        {systemData.address.city && <>
                                            {systemData.address.city}
                                        </>}
                                        {systemData.address.state && <>
                                            {(systemData.address.city ? ', ' : '') + (systemData.address.state) + ' '}<br />
                                        </>}
                                        {systemData.address.postcode && <>
                                            {systemData.address.postcode}
                                        </>}
                                    </>
                                ) : '--'
                            }
                        </ValueDisplay>
                    </div>
                </div>
            </Panel>
            <Panel
                title="Payee Information"
                contentStyle={{ padding: 20 }}
                headerStyle={{
                    borderBottomWidth: 1,
                    borderStyle: 'solid',
                    borderColor: '#E2E3E8',
                    padding: 20
                }}
            >
                <div className='row'>
                    <div className='col-12 col-xl-6'>
                        <ValueDisplay
                            label="Payee"
                            value={paymentData.person_name || '--'}
                        />
                    </div>
                    <div className='col-12 col-xl-6'>
                        <ValueDisplay
                            label="Payment Address"
                        >
                            {
                                paymentData.address ? (
                                    <>
                                        {paymentData.address.street && <>
                                            {paymentData.address.street}<br />
                                        </>}
                                        {paymentData.address.street_2 && <>
                                            {paymentData.address.street_2}<br />
                                        </>}
                                        {paymentData.address.city && <>
                                            {paymentData.address.city}
                                        </>}
                                        {paymentData.address.state && <>
                                            {(paymentData.address.city ? ', ' : '') + (paymentData.address.state) + ' '}<br />
                                        </>}
                                        {paymentData.address.postcode && <>
                                            {paymentData.address.postcode}
                                        </>}
                                    </>
                                ) : '--'
                            }
                        </ValueDisplay>
                    </div>
                </div>
            </Panel>
        </div>
    );
};